import { useLocation, useParams } from "react-router-dom";
import { unzip } from "@repo/utils";
import { useEstimateEditorStore } from "@tools";

export const useLocationHash = () => {
  
  const location = useLocation();
  const { versionKey } = useParams();
  const editorStore = useEstimateEditorStore();
  
  const handleLocationHash = () => {
    let defaultVersionKey;
    
    if(versionKey && editorStore.sortedVersions.find(v => v.key === Number(versionKey))) {
      defaultVersionKey = Number(versionKey);
    }
    
    const hash = location.hash.slice(1);
    if(hash) {
      // navigate({
      //   pathname: location.pathname,
      //   hash: "",
      // }, { preventScrollReset: true, replace: true });
      
      try {
        const u = JSON.parse(unzip(hash));
        if ( u.version && editorStore.estimateVersions.find(v => v.key === Number(u.version)) ) {
          u.version = Number(u.version);
          u.path = u.place || u.path;
          defaultVersionKey = u.version;
          
          editorStore.setDisplayedComment(u);
        }
      } catch (e) {
        // const potentialVersionKey = Number(hash);
        // if ( !isNaN(potentialVersionKey) && editorStore.sortedVersions.find(v => v.key === potentialVersionKey) )
        //   defaultVersionKey = potentialVersionKey;
        
        /** @note: handle other hashes here */
      }
    }
    
    return defaultVersionKey;
  }
  
  return { handleLocationHash }
}